import { all } from 'redux-saga/effects';
import edit from 'sagas/location/edit';
import list from 'sagas/location/list';

export default function* location() {
  yield all([list(), edit()]);
}
